import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IWsProductoCartResult, WsProductoCartResult, IProductoCartClasificacion } from '../classes/ws-producto-cart';
import { ApiResponse } from '../dto';
import { handleApiError } from '../utils';

@Injectable()
export class WsProductoCartService {
	endpoint = `/api/productos-cart`;

	constructor(private http: HttpClient) { }

	get(filters: any): Observable<ApiResponse<any>> {
		let params = new HttpParams();
		Object.keys(filters).forEach(key => {
			if (filters[key] !== null && filters[key] !== undefined) {
				params = params.set(key, filters[key]);
			}
		});

		return this.http.get<ApiResponse<any>>(`${this.endpoint}`, { headers: { context: '.products-grid' }, params })
			.pipe(
				map((data: ApiResponse<any>) => {
					const datos = data.Data?.datos ?? [];
					datos.forEach((res: any) => {
						res.Galeria = typeof res.Galeria === 'string' ? JSON.parse(res.Galeria) : [{ Ruta: '' }];
					});

					return data;
				})
			);
	}

	getProducto(id: number, ctx?): Observable<WsProductoCartResult> {
		return this.http.get<IWsProductoCartResult>(`${this.endpoint}/${id}`, { headers: { context: ctx || 'body' } })
			.pipe(
				map(res => new WsProductoCartResult(res))
			);
	}

	getStock(lista: any, ctx?): Observable<any> {
		const headers = { context: '.products', caption: 'Actualizando información del stock...' };
		// const headers = { context: ctx, caption: ' ' };
		return this.http.post<any>(`${this.endpoint}/stock`, lista, { headers });
	}

	getLineas(): Observable<IProductoCartClasificacion[]> {
		// return this.http.get<IProductoCartClasificacion[]>(`${this.endpoint}/clasificacion/lineas`);

		return new Observable<IProductoCartClasificacion[]>(observer => {
			const result: [] = [
				{ Id: '30', Detalle: 'ETIQUETAS' },
				{ Id: '31', Detalle: 'CINTAS DE IMPRESIÓN' }
			] as unknown as [];
			observer.next(result);
		});
	}

	getGrupos(IdLinea: string): Observable<IProductoCartClasificacion[]> {
		const headers = new HttpHeaders({ context: '.clsGrupos' });
		return this.http.get<IProductoCartClasificacion[]>(`${this.endpoint}/clasificacion/grupos/${IdLinea}`, { headers });
	}

	getTipos(IdLinea: string, IdGrupo: string): Observable<IProductoCartClasificacion[]> {
		const headers = new HttpHeaders({ context: '.clsTipos' });
		return this.http.get<IProductoCartClasificacion[]>(`${this.endpoint}/clasificacion/tipos/${IdLinea}/${IdGrupo}`, { headers });
	}

	getFamilias(IdLinea: string, IdGrupo: string, IdTipo: string): Observable<IProductoCartClasificacion[]> {
		const headers = new HttpHeaders({ context: '.clsFamilias' });
		return this.http.get<IProductoCartClasificacion[]>(`${this.endpoint}/clasificacion/familias/${IdLinea}/${IdGrupo}/${IdTipo}`, { headers });
	}

	getJerarquias(nivel: number = 1, id_nivel_padre: number = null): Observable<any[]> {
		const headers = new HttpHeaders({ context: `.nivel_${nivel}` });
		return this.http.get<any[]>(`${this.endpoint}/jerarquias?nivel=${nivel}&id_nivel_padre=${id_nivel_padre}`, { headers });
	}

	listarByCliente(idCliente: number): Observable<ApiResponse<any>> {
		return this.http.get<ApiResponse<any>>(`${this.endpoint}/listar/${idCliente}`, { headers: { context: 'body' } }).pipe(
			catchError(handleApiError<any>())
		);
	}

}
